'use strict';

var moment = require('moment');
var _ = require('lodash');
var ChartExampleDataProviderService = function ChartExampleDataProviderService(seasonColorService) {
  var seasons = ['PEAK', 'HIGH', 'SHOULDER', 'LOW'];
  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
  }
  function generateData() {
    var result = [];
    for (var i = 0; i < 100; i++) {
      result.push({
        current: getRandomInt(1000, 4000),
        expected: getRandomInt(0, 5000),
        season: seasons[Math.floor(i / 10) % seasons.length]
      });
    }
    return result;
  }

  // this will normally download the data from the REST API
  function retrieveData(selectedMetric) {
    if (selectedMetric === 'Bookings' || selectedMetric === 'Revenue') {
      return generateData();
    } else if (selectedMetric === 'Yield') {
      return []; // empty data set
    } else {
      return undefined; // error retrieving data
    }
  }
  function getData(selectedMetric) {
    var date = moment().startOf('day');
    var apiData = retrieveData(selectedMetric);

    // error retrieving data
    if (apiData === undefined) {
      return {
        data: undefined,
        legend: []
      };
    }

    // transform
    var data = _.map(apiData, function (d) {
      var o = Object.create(null);
      o.m1 = d.current;
      o.m2 = d.expected;
      o.label = d.season;
      o.visible = true;
      o.d1 = moment(date.add(1, 'days'));
      o.fill = seasonColorService.getColor(d.season);
      return o;
    });

    // add some gaps
    if (data.length > 20) {
      data.splice(10, 1, {
        d1: data[10].d1,
        isGap: true
      });
      data.splice(20, 5, {
        d2: data[20].d1,
        isGap: true
      });
    }

    // prepare legend
    var legendMapped = _.chain(data).uniqBy('label').filter(function (d) {
      return !d.isGap;
    }).map(function (d) {
      return {
        label: d.label,
        fill: d.fill
      };
    }).value();
    return {
      data: data,
      legend: legendMapped
    };
  }
  return {
    getData: getData
  };
};
ChartExampleDataProviderService.$inject = ['SeasonColorService'];
module.exports = ChartExampleDataProviderService;